import { Link } from 'react-router-dom';

import PropertyVisual from '../components/PropertyVisual';
import { useLanguage } from '../context/LanguageContext';
import { site } from '../data/site';

function LocationPage() {
  const { language, t } = useLanguage();
  const copy = language === 'ru'
    ? {
        title: 'Святой‑Стефан — образ Черногории на Адриатике',
        lead: 'Каменный остров с терракотовыми крышами, соединённый с берегом узким перешейком, стал одним из самых узнаваемых пейзажей всего региона',
        chapters: [
          ['Остров и его история', 'Укреплённое поселение связано с общиной Паштровичей и XV веком. За стенами сохранился силуэт средневекового городка с тесными улицами, площадями и небольшими церквями.'],
          ['Пляжи Святого‑Стефана', 'По обе стороны перешейка лежат галечные пляжи с прозрачной водой. От резиденции к берегу ведут пешеходные маршруты и лестницы — рельеф здесь живописный и холмистый.'],
          ['Милочер и Королевский парк', 'Севернее острова начинается прибрежная прогулка к Милочеру через сосны, кипарисы и старые оливковые деревья. В этой части побережья находятся пляжи Милочер и Королевы.'],
          ['Пржно и местная кухня', 'Небольшой рыбацкий посёлок Пржно расположен дальше по берегу. Здесь удобно совместить прогулку с ужином у моря и блюдами черногорской и средиземноморской кухни.'],
          ['Будванская ривьера', 'Старый город Будвы, Бечичи, Петровац и монастыри Паштровичей позволяют легко дополнить пляжный отдых короткими поездками по побережью.'],
          ['Парковка и трансфер', 'В здании есть частная парковка. По предварительной договорённости мы организуем трансфер из аэропорта или в аэропорт за дополнительную плату.'],
        ],
        map: 'Открыть в Google Maps',
        closing: 'Остановитесь рядом с символом Адриатики',
      }
    : {
        title: 'Sveti Stefan, Montenegro’s icon on the Adriatic',
        lead: 'The stone islet and its terracotta roofs, joined to the shore by a narrow causeway, form one of the region’s most recognisable landscapes',
        chapters: [
          ['The island and its story', 'The fortified settlement dates back to the 15th century and is closely tied to the Paštrovići community. Behind its walls, narrow lanes, small squares and churches preserve the character of a medieval village.'],
          ['Sveti Stefan beaches', 'Pebble beaches washed by clear water lie on both sides of the causeway. Walking paths and steps lead down from the residence through the green, naturally hilly landscape.'],
          ['Miločer and the royal park', 'North of the island, a coastal path winds towards Miločer through pines, cypresses and old olive trees, passing Miločer Beach and Queen’s Beach.'],
          ['Pržno and local food', 'The small fishing village of Pržno lies farther along the shore, making it easy to combine a coastal walk with Montenegrin and Mediterranean food by the water.'],
          ['The Budva Riviera', 'Budva Old Town, Bečići, Petrovac and the historic monasteries of Paštrovići make it easy to complement time by the sea with cultural and scenic day trips.'],
          ['Parking and transfers', 'Private parking is available at the residence. Airport transfers can be arranged in advance for an additional charge.'],
        ],
        map: 'Open in Google Maps',
        closing: 'Stay beside an icon of the Adriatic',
      };

  return (
    <article className="location-page">
      <header className="page-intro">
        <span className="eyebrow">Sveti Stefan · Budva Riviera</span>
        <h1>{copy.title}</h1>
        <p>{copy.lead}</p>
      </header>

      <PropertyVisual src="/images/property/120.jpg" alt="Sveti Stefan island and beach" eager className="location-page__hero" />

      <div className="location-chapters">
        {copy.chapters.map(([title, text]) => (
          <section key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </section>
        ))}
      </div>

      <section className="map-panel">
        <iframe title="Adriatic Masterpiece Residence map" src={site.mapEmbedUrl} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        <div className="map-panel__card">
          <span className="eyebrow">AMR</span>
          <h2>{site.location}</h2>
          <a className="text-link" href={site.mapUrl} target="_blank" rel="noreferrer">{copy.map} <span>↗</span></a>
        </div>
      </section>

      <section className="closing-cta">
        <h2>{copy.closing}</h2>
        <Link className="button" to="/book">{t('common.book')}</Link>
      </section>
    </article>
  );
}

export default LocationPage;
